import { render, staticRenderFns } from "./Day10.vue?vue&type=template&id=52d053da&"
import script from "./Day10.vue?vue&type=script&lang=js&"
export * from "./Day10.vue?vue&type=script&lang=js&"
import style0 from "./Day10.vue?vue&type=style&index=0&id=52d053da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports